import React, { useCallback } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';

import metadata from './CPQuotePage.metadata.json5';

import styles from './CPQuotePage.module.scss';
import './CPQuotePage.messages';

function CPQuotePage(props) {
    const { wizardData: submissionVM, steps, jumpTo } = props;
    const handleNext = useCallback(() => {
        const offeredQuotes = _.get(submissionVM.value, 'quoteData.offeredQuotes[0].publicID');
        _.set(submissionVM, 'bindData.chosenQuote', offeredQuotes);
        return submissionVM;
    }, [submissionVM]);

    const handlePrint = () => {
        window.print();
    };

    const navigateToCoverages = useCallback(() => {
        const indexOfGeneralCoverages = _.findIndex(
            steps,
            ({ path }) => path === '/buildings-and-locations'
        );
        jumpTo(indexOfGeneralCoverages);
    }, [jumpTo, steps]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            navigateToCoverages: navigateToCoverages,
            onPrint: handlePrint
        }
    };

    const overrides = {
        '@field': {
            labelPosition: 'left'
        }
    };

    return (
        <WizardPage onNext={handleNext}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

CPQuotePage.propTypes = wizardProps;
export default CPQuotePage;
